// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.button-module__button___zGbs9 {
  width: 100%;
  font-weight: 500;
  text-align: center;
  position: relative;
  padding: 0 20px;
  border-radius: 36px;
  -webkit-appearance: button;
     -moz-appearance: button;
          appearance: button;
  cursor: pointer;
  -webkit-appearance: none;
}
.button-module__button___zGbs9:focus {
  outline: var(--focus, #2681e1) solid 2px;
  outline-offset: 3px;
}
.button-module__button___zGbs9 svg {
  min-height: 16px;
  max-height: 16px;
  min-width: 16px;
  max-width: 16px;
  margin-right: -3px;
  margin-left: 6px;
}
.button-module__button--icon-left___ewWST {
  flex-direction: row-reverse;
}
.button-module__button--icon-left___ewWST svg {
  margin-right: 6px;
  margin-left: -3px;
}
.button-module__button--flex___FWCq5 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-module__button--inline-flex___AVlj_ {
  display: inline-flex;
}
.button-module__button--flex___FWCq5:after, .button-module__button--inline-flex___AVlj_:after {
  content: "";
  display: block;
  min-height: inherit;
  font-size: 0;
}
.button-module__button___zGbs9:disabled {
  opacity: 0.3;
}
.button-module__button--teal-outline___GcWX1:focus {
  outline: var(--green300, #2b8000) solid 2px;
  outline-offset: 3px;
}
.button-module__button--blue-outline___GiQlK:focus {
  outline: var(--primary600, #4b286d) solid 2px;
  outline-offset: 3px;
}

/********************** SIZES ***********************/
/********* X-LARGE, LARGE, SMALL, X-SMALL **********/
.button-module__x-large___DR8L_ {
  min-height: 48px;
  font-size: 1.25rem;
  min-width: 90px;
  border-radius: 48px;
}

.button-module__large___InIX7 {
  min-height: 40px;
  font-size: 1rem;
  min-width: 80px;
  border-radius: 36px;
}

.button-module__small___uWCNe {
  min-height: 30px;
  font-size: 0.875rem;
  min-width: 70px;
  border-radius: 32px;
}

.button-module__x-small___S6ynG {
  min-height: 24px;
  font-size: 0.75rem;
  min-width: 60px;
  border-radius: 24px;
}

/********************** THEMES *********************/
/***** PRIMARY, PRIMARY-LIGHT, SURFACE, INLINE, TOGGLE-ON, TOGGLE-OFF *****/
.button-module__contained--on-surface___hXhlB {
  background-color: var(--primary600, #4b286d);
  border: none;
  box-shadow: 0 8px 24px rgba(var(--primary200-rgb, 216, 203, 229), 0.24);
}
.button-module__contained--on-surface___hXhlB, .button-module__contained--on-surface___hXhlB:hover, .button-module__contained--on-surface___hXhlB:focus {
  color: var(--surface1, #fff);
  box-shadow: 0 8px 16px rgba(var(--primary200-rgb, 216, 203, 229), 0.24);
}
.button-module__contained--on-surface--loaded___G_UoE:hover:not([disabled]), .button-module__contained--on-surface--loaded___G_UoE:focus:not([disabled]) {
  background-color: var(--primary700, #371e47);
}
.button-module__contained--on-surface___hXhlB svg {
  fill: var(--surface1, #fff);
}

.button-module__contained--on-surface-delete___CWK5V {
  background-color: var(--red600, #c12335);
  border: none;
  box-shadow: 0 8px 24px rgba(var(--primary200-rgb, 216, 203, 229), 0.24);
}
.button-module__contained--on-surface-delete___CWK5V, .button-module__contained--on-surface-delete___CWK5V:hover, .button-module__contained--on-surface-delete___CWK5V:focus {
  color: var(--surface1, #fff);
  box-shadow: 0 8px 16px rgba(var(--primary200-rgb, 216, 203, 229), 0.24);
}
.button-module__contained--on-surface-delete--loaded___uUul4:hover:not([disabled]), .button-module__contained--on-surface-delete--loaded___uUul4:focus:not([disabled]) {
  background-color: var(--primary700, #371e47);
}
.button-module__contained--on-surface-delete___CWK5V svg {
  fill: var(--surface1, #fff);
}

.button-module__contained--on-primary___pCwlK {
  background-color: var(--surface1, #fff);
  border: none;
  box-shadow: 0 8px 24px rgba(var(--surface1-rgb, 255, 255, 255), 0.24);
  color: var(--primary600, #4b286d);
}
.button-module__contained--on-primary___pCwlK, .button-module__contained--on-primary___pCwlK:hover, .button-module__contained--on-primary___pCwlK:focus {
  color: var(--primary700, #371e47);
  box-shadow: 0 8px 16px rgba(var(--primary200-rgb, 216, 203, 229), 0.24);
}
.button-module__contained--on-primary--loaded___OEkUF:hover:not([disabled]), .button-module__contained--on-primary--loaded___OEkUF:focus:not([disabled]) {
  background-color: var(--primary200, #d8cbe5);
}
.button-module__contained--on-primary___pCwlK svg {
  fill: var(--primary600, #4b286d);
}

.button-module__contained--on-primary-brand___JfAxd {
  background-color: var(--neutral100, #2c2e30);
  border: none;
  box-shadow: 0 8px 24px rgba(var(--neutral100-rgb, 44, 46, 48), 0.24);
  color: var(--surface1, #fff);
}
.button-module__contained--on-primary-brand___JfAxd, .button-module__contained--on-primary-brand___JfAxd:hover, .button-module__contained--on-primary-brand___JfAxd:focus {
  box-shadow: 0 8px 16px rgba(var(--neutral100-rgb, 44, 46, 48), 0.24);
}
.button-module__contained--on-primary-brand--loaded___xit9c:hover:not([disabled]), .button-module__contained--on-primary-brand--loaded___xit9c:focus:not([disabled]) {
  background-color: var(--neutral75, #424547);
}
.button-module__contained--on-primary-brand___JfAxd svg {
  fill: var(--surface1, #fff);
}

.button-module__outlined--on-surface___Roeju {
  border: 1px solid var(--primary600, #4b286d);
  background-color: var(--surface1, #fff);
}
.button-module__outlined--on-surface___Roeju, .button-module__outlined--on-surface___Roeju:hover, .button-module__outlined--on-surface___Roeju:focus {
  color: var(--primary600, #4b286d);
}
.button-module__outlined--on-surface--loaded___oKgh8:hover:not([disabled]), .button-module__outlined--on-surface--loaded___oKgh8:focus:not([disabled]) {
  background-color: rgba(var(--primary700-rgb, 55, 30, 71), 0.24);
  color: var(--primary700, #371e47);
}
.button-module__outlined--on-surface___Roeju svg {
  fill: var(--primary600, #4b286d);
}

.button-module__outlined--on-surface-delete___PoSCq {
  border: 1px solid var(--red600, #c12335);
  background-color: var(--surface1, #fff);
}
.button-module__outlined--on-surface-delete___PoSCq, .button-module__outlined--on-surface-delete___PoSCq:hover, .button-module__outlined--on-surface-delete___PoSCq:focus {
  color: var(--red600, #c12335);
}
.button-module__outlined--on-surface-delete--loaded___6xkOD:hover:not([disabled]), .button-module__outlined--on-surface-delete--loaded___6xkOD:focus:not([disabled]) {
  background-color: rgba(var(--primary700-rgb, 55, 30, 71), 0.24);
  color: var(--primary700, #371e47);
}
.button-module__outlined--on-surface-delete___PoSCq svg {
  fill: var(--red600, #c12335);
}

.button-module__outlined--on-primary___STG6N {
  border: 1px solid var(--surface1, #fff);
  background-color: var(--primary600, #4b286d);
}
.button-module__outlined--on-primary___STG6N, .button-module__outlined--on-primary___STG6N:hover, .button-module__outlined--on-primary___STG6N:focus {
  color: var(--surface1, #fff);
}
.button-module__outlined--on-primary--loaded___aVhAd:hover:not([disabled]), .button-module__outlined--on-primary--loaded___aVhAd:focus:not([disabled]) {
  background-color: rgba(var(--surface1-rgb, 255, 255, 255), 0.24);
  color: var(--surface1, #fff);
}
.button-module__outlined--on-primary___STG6N svg {
  fill: var(--surface1, #fff);
}

.button-module__outlined--on-primary-brand___Yh2Mb {
  border: 1px solid var(--neutral100, #2c2e30);
  background-color: var(--primary300, #7c53a5);
}
.button-module__outlined--on-primary-brand___Yh2Mb, .button-module__outlined--on-primary-brand___Yh2Mb:hover, .button-module__outlined--on-primary-brand___Yh2Mb:focus {
  color: var(--neutral100, #2c2e30);
}
.button-module__outlined--on-primary-brand--loaded___xzKeV:hover:not([disabled]), .button-module__outlined--on-primary-brand--loaded___xzKeV:focus:not([disabled]) {
  background-color: rgba(var(--neutral100-rgb, 44, 46, 48), 0.24);
  color: var(--neutral100, #2c2e30);
}
.button-module__outlined--on-primary-brand___Yh2Mb svg {
  fill: var(--neutral100, #2c2e30);
}

.button-module__text--on-surface___Dx7M6 {
  border: none;
  background-color: transparent;
  padding: 0 4px;
  min-height: 0;
  width: auto;
}
.button-module__text--on-surface___Dx7M6 svg {
  margin-right: 0;
  margin-top: 1px;
}
.button-module__text--on-surface--icon-left___BhnEN {
  text-align: left;
}
.button-module__text--on-surface--icon-left___BhnEN svg {
  margin-right: 6px;
  margin-left: 0;
}
.button-module__text--on-surface___Dx7M6, .button-module__text--on-surface___Dx7M6:hover, .button-module__text--on-surface___Dx7M6:focus {
  color: var(--primary600, #4b286d);
}
.button-module__text--on-surface--loaded___te3zH:hover:not([disabled]), .button-module__text--on-surface--loaded___te3zH:focus:not([disabled]) {
  background-color: rgba(var(--primary700-rgb, 55, 30, 71), 0.24);
  color: var(--primary700, #371e47);
}
.button-module__text--on-surface___Dx7M6 svg {
  fill: var(--primary600, #4b286d);
}
.button-module__text--on-surface--disabled___I99GA {
  opacity: 0.3;
}
.button-module__text--on-surface--disabled___I99GA:hover, .button-module__text--on-surface--disabled___I99GA:focus {
  color: var(--primary600, #4b286d);
}

.button-module__text--on-primary___erlw5 {
  border: none;
  background-color: transparent;
  padding: 0 4px;
  min-height: 0;
  width: auto;
}
.button-module__text--on-primary___erlw5 svg {
  margin-right: 0;
  margin-top: 1px;
}
.button-module__text--on-primary--icon-left___PrUFA {
  text-align: left;
}
.button-module__text--on-primary--icon-left___PrUFA svg {
  margin-right: 6px;
  margin-left: 0;
}
.button-module__text--on-primary___erlw5, .button-module__text--on-primary___erlw5:hover, .button-module__text--on-primary___erlw5:focus {
  color: var(--surface1, #fff);
}
.button-module__text--on-primary--loaded___ZYTRC:hover:not([disabled]), .button-module__text--on-primary--loaded___ZYTRC:focus:not([disabled]) {
  background-color: rgba(var(--surface1-rgb, 255, 255, 255), 0.24);
  color: var(--surface1, #fff);
}
.button-module__text--on-primary___erlw5 svg {
  fill: var(--surface1, #fff);
}
.button-module__text--on-primary--disabled___Po7Ip {
  opacity: 0.3;
}
.button-module__text--on-primary--disabled___Po7Ip:hover, .button-module__text--on-primary--disabled___Po7Ip:focus {
  color: var(--primary600, #4b286d);
}

.button-module__text--on-primary-brand___xAbaZ {
  border: none;
  background-color: transparent;
  padding: 0 4px;
  min-height: 0;
  width: auto;
}
.button-module__text--on-primary-brand___xAbaZ svg {
  margin-right: 0;
  margin-top: 1px;
}
.button-module__text--on-primary-brand--icon-left___vEC0M {
  text-align: left;
}
.button-module__text--on-primary-brand--icon-left___vEC0M svg {
  margin-right: 6px;
  margin-left: 0;
}
.button-module__text--on-primary-brand___xAbaZ, .button-module__text--on-primary-brand___xAbaZ:hover, .button-module__text--on-primary-brand___xAbaZ:focus {
  color: var(--neutral100, #2c2e30);
}
.button-module__text--on-primary-brand--loaded___zrpVR:hover:not([disabled]), .button-module__text--on-primary-brand--loaded___zrpVR:focus:not([disabled]) {
  background-color: rgba(var(--neutral100-rgb, 44, 46, 48), 0.24);
  color: var(--neutral100, #2c2e30);
}
.button-module__text--on-primary-brand___xAbaZ svg {
  fill: var(--neutral100, #2c2e30);
}
.button-module__text--on-primary-brand--disabled___VHr7I {
  opacity: 0.3;
}
.button-module__text--on-primary-brand--disabled___VHr7I:hover, .button-module__text--on-primary-brand--disabled___VHr7I:focus {
  color: var(--primary600, #4b286d);
}

.button-module__toggle-on___gFIp3 {
  color: var(--primary600, #4b286d);
  border: 1px solid var(--primary600, #4b286d);
  background-color: rgba(var(--primary600-rgb, 75, 40, 109), 0.15);
}

.button-module__toggle-off___CS8K0 {
  color: var(--neutral75, #424547);
  border: 1px solid var(--neutral75, #424547);
  background-color: transparent;
}
.button-module__toggle-off___CS8K0:hover, .button-module__toggle-off___CS8K0:focus {
  background-color: rgba(var(--neutral75-rgb, 66, 69, 71), 0.15);
}

/**************************************************/
.button-module__loading___cyMW5, .button-module__loading___cyMW5:hover, .button-module__loading___cyMW5:focus {
  cursor: default;
  color: rgba(var(--neutral100-rgb, 44, 46, 48), 0);
}
.button-module__loading___cyMW5 svg * {
  opacity: 0;
}

/* rtl:begin:ignore */
@keyframes button-module__spin___KY71k {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/* rtl:end:ignore */
.button-module__spinner___moqCn {
  height: 22px;
  width: 22px;
}
.button-module__spinner___moqCn {
  animation: button-module__spin___KY71k 0.75s infinite linear;
}
.button-module__spinner__wrapper___EvrkF {
  height: 22px;
  width: 22px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.button-module__non-inline-anchor--disabled___ZcJz8 {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./node_modules/wa-storybook/components/general/button/button.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_focus-outline.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_hocus.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACcA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;KAAA,uBAAA;UAAA,kBAAA;EACA,eAAA;EAGA,wBAAA;AARF;ACVI;EACE,wCAAA;EACA,mBAAA;ADYN;AAQE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AANJ;AASE;EACE,2BAAA;AAPJ;AASI;EACE,iBAAA;EACA,iBAAA;AAPN;AAWE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AATJ;AAYE;EACE,oBAAA;AAVJ;AAeI;EAEE,WAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAdN;AAkBE;EACE,YAAA;AAhBJ;AC9CI;EACE,2CAAA;EACA,mBAAA;ADgDN;AClDI;EACE,6CAAA;EACA,mBAAA;ADoDN;;AAoBA,qDAAA;AACA,oDAAA;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAlBF;;AAqBA,oDAAA;AACA,2EAAA;AAEA;EACE,4CAAA;EACA,YAAA;EACA,uEAAA;AAnBF;AAqBE;EAGE,4BAAA;EACA,uEAAA;AArBJ;AA2BM;EACE,4CAAA;AAzBR;AA8BE;EACE,2BAAA;AA5BJ;;AA+BA;EACE,wCAAA;EACA,YAAA;EACA,uEAAA;AA5BF;AA8BE;EAGE,4BAAA;EACA,uEAAA;AA9BJ;AAoCM;EACE,4CAAA;AAlCR;AAuCE;EACE,2BAAA;AArCJ;;AAyCA;EACE,uCAAA;EACA,YAAA;EACA,qEAAA;EACA,iCAAA;AAtCF;AAwCE;EAGE,iCAAA;EACA,uEAAA;AAxCJ;AA8CM;EACE,4CAAA;AA5CR;AAiDE;EACE,gCAAA;AA/CJ;;AAmDA;EACE,4CAAA;EACA,YAAA;EACA,oEAAA;EACA,4BAAA;AAhDF;AAkDE;EAGE,oEAAA;AAlDJ;AAwDM;EACE,2CAAA;AAtDR;AA2DE;EACE,2BAAA;AAzDJ;;AA6DA;EACE,4CAAA;EACA,uCAAA;AA1DF;AA4DE;EAGE,iCAAA;AA5DJ;AAkEM;EACE,+DAAA;EACA,iCAAA;AAhER;AAqEE;EACE,gCAAA;AAnEJ;;AAuEA;EACE,wCAAA;EACA,uCAAA;AApEF;AAsEE;EAGE,6BAAA;AAtEJ;AA4EM;EACE,+DAAA;EACA,iCAAA;AA1ER;AA+EE;EACE,4BAAA;AA7EJ;;AAiFA;EACE,uCAAA;EACA,4CAAA;AA9EF;AAgFE;EAGE,4BAAA;AAhFJ;AAsFM;EACE,gEAAA;EACA,4BAAA;AApFR;AAyFE;EACE,2BAAA;AAvFJ;;AA2FA;EACE,4CAAA;EACA,4CAAA;AAxFF;AA0FE;EAGE,iCAAA;AA1FJ;AAgGM;EACE,+DAAA;EACA,iCAAA;AA9FR;AAmGE;EACE,gCAAA;AAjGJ;;AAqGA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AAlGF;AAoGE;EACE,eAAA;EACA,eAAA;AAlGJ;AAqGE;EACE,gBAAA;AAnGJ;AAqGI;EACE,iBAAA;EACA,cAAA;AAnGN;AAuGE;EAGE,iCAAA;AAvGJ;AA6GM;EACE,+DAAA;EACA,iCAAA;AA3GR;AAgHE;EACE,gCAAA;AA9GJ;AAiHE;EACE,YAAA;AA/GJ;AAiHI;EAEE,iCAAA;AAhHN;;AAqHA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AAlHF;AAoHE;EACE,eAAA;EACA,eAAA;AAlHJ;AAqHE;EACE,gBAAA;AAnHJ;AAqHI;EACE,iBAAA;EACA,cAAA;AAnHN;AAuHE;EAGE,4BAAA;AAvHJ;AA6HM;EACE,gEAAA;EACA,4BAAA;AA3HR;AAgIE;EACE,2BAAA;AA9HJ;AAiIE;EACE,YAAA;AA/HJ;AAiII;EAEE,iCAAA;AAhIN;;AAqIA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;AAlIF;AAoIE;EACE,eAAA;EACA,eAAA;AAlIJ;AAqIE;EACE,gBAAA;AAnIJ;AAqII;EACE,iBAAA;EACA,cAAA;AAnIN;AAuIE;EAGE,iCAAA;AAvIJ;AA6IM;EACE,+DAAA;EACA,iCAAA;AA3IR;AAgJE;EACE,gCAAA;AA9IJ;AAiJE;EACE,YAAA;AA/IJ;AAiJI;EAEE,iCAAA;AAhJN;;AAqJA;EACE,iCAAA;EACA,4CAAA;EACA,gEAAA;AAlJF;;AAqJA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;AAlJF;AE1UE;EF+dE,8DAAA;AAlJJ;;AAsJA,mDAAA;AAGE;EAGE,eAAA;EACA,iDAAA;AAvJJ;AA0JE;EACE,UAAA;AAxJJ;;AA4JA,qBAAA;AACA;EACE;IACE,uBAAA;EAzJF;EA2JA;IACE,yBAAA;EAzJF;AACF;AA2JA,mBAAA;AAEA;EAIE,YAAA;EACA,WAAA;AA7JF;AAyJE;EACE,4DAAA;AAvJJ;AA4JE;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,kBAAA;AA1JJ;;AA8JA;EACE,YAAA;AA3JF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '../../../styles/utils.scss';\n\n// Do not modify this file for styling purposes.\n// Wrap the button.tsx import in a <div> and apply styles\n// (margin/padding/flex/flex-basis etc) to that div instead.\n//\n// Because the button has \"width: 100%\", to give it its\n// natural width simply make the wrapping <div>\n// \"display:inline-block\" or \"position: absolute\".\n// wrapping it in flexbox might also achieve it.\n//\n// For consistent UI, never give the wrapping <div>\n// an exact value for width and height.\n\n.button {\n  width: 100%;\n  font-weight: 500;\n  text-align: center;\n  position: relative;\n  padding: 0 20px;\n  border-radius: 36px;\n  appearance: button;\n  cursor: pointer;\n\n  // Safari fix, not loading styles on div or span tags\n  -webkit-appearance: none;\n\n  @include focus-outline;\n\n  svg {\n    min-height: 16px;\n    max-height: 16px;\n    min-width: 16px;\n    max-width: 16px;\n    margin-right: -3px;\n    margin-left: 6px;\n  }\n\n  &--icon-left {\n    flex-direction: row-reverse;\n\n    svg {\n      margin-right: 6px;\n      margin-left: -3px;\n    }\n  }\n\n  &--flex {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &--inline-flex {\n    display: inline-flex;\n  }\n\n  &--flex,\n  &--inline-flex {\n    &:after {\n      //IE11 flexbox bugfix - https://github.com/philipwalton/flexbugs/issues/231\n      content: '';\n      display: block; //block needed to make IE11 see it\n      min-height: inherit;\n      font-size: 0;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.3;\n  }\n\n  &--teal-outline {\n    @include focus-outline(color(green300));\n  }\n\n  &--blue-outline {\n    @include focus-outline(color(primary600));\n  }\n}\n\n/********************** SIZES ***********************/\n/********* X-LARGE, LARGE, SMALL, X-SMALL **********/\n\n.x-large {\n  min-height: 48px;\n  font-size: rem(20);\n  min-width: 90px;\n  border-radius: 48px;\n}\n\n.large {\n  min-height: 40px;\n  font-size: rem(16);\n  min-width: 80px;\n  border-radius: 36px;\n}\n\n.small {\n  min-height: 30px;\n  font-size: rem(14);\n  min-width: 70px;\n  border-radius: 32px;\n}\n\n.x-small {\n  min-height: 24px;\n  font-size: rem(12);\n  min-width: 60px;\n  border-radius: 24px;\n}\n\n/********************** THEMES *********************/\n/***** PRIMARY, PRIMARY-LIGHT, SURFACE, INLINE, TOGGLE-ON, TOGGLE-OFF *****/\n\n.contained--on-surface {\n  background-color: color(primary600);\n  border: none;\n  box-shadow: 0 8px 24px rgba(color(primary200, true), 0.24);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(surface1);\n    box-shadow: 0 8px 16px rgba(color(primary200, true), 0.24);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: color(primary700);\n      }\n    }\n  }\n\n  svg {\n    fill: color(surface1);\n  }\n}\n.contained--on-surface-delete {\n  background-color: color(red600);\n  border: none;\n  box-shadow: 0 8px 24px rgba(color(primary200, true), 0.24);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(surface1);\n    box-shadow: 0 8px 16px rgba(color(primary200, true), 0.24);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: color(primary700);\n      }\n    }\n  }\n\n  svg {\n    fill: color(surface1);\n  }\n}\n\n.contained--on-primary {\n  background-color: color(surface1);\n  border: none;\n  box-shadow: 0 8px 24px rgba(color(surface1, true), 0.24);\n  color: color(primary600);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(primary700);\n    box-shadow: 0 8px 16px rgba(color(primary200, true), 0.24);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: color(primary200);\n      }\n    }\n  }\n\n  svg {\n    fill: color(primary600);\n  }\n}\n\n.contained--on-primary-brand {\n  background-color: color(neutral100);\n  border: none;\n  box-shadow: 0 8px 24px rgba(color(neutral100, true), 0.24);\n  color: color(surface1);\n\n  &,\n  &:hover,\n  &:focus {\n    box-shadow: 0 8px 16px rgba(color(neutral100, true), 0.24);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: color(neutral75);\n      }\n    }\n  }\n\n  svg {\n    fill: color(surface1);\n  }\n}\n\n.outlined--on-surface {\n  border: 1px solid color(primary600);\n  background-color: color(surface1);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(primary600);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(primary700, true), 0.24);\n        color: color(primary700);\n      }\n    }\n  }\n\n  svg {\n    fill: color(primary600);\n  }\n}\n\n.outlined--on-surface-delete {\n  border: 1px solid color(red600);\n  background-color: color(surface1);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(red600);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(primary700, true), 0.24);\n        color: color(primary700);\n      }\n    }\n  }\n\n  svg {\n    fill: color(red600);\n  }\n}\n\n.outlined--on-primary {\n  border: 1px solid color(surface1);\n  background-color: color(primary600);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(surface1);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(surface1, true), 0.24);\n        color: color(surface1);\n      }\n    }\n  }\n\n  svg {\n    fill: color(surface1);\n  }\n}\n\n.outlined--on-primary-brand {\n  border: 1px solid color(neutral100);\n  background-color: color(primary300);\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(neutral100);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(neutral100, true), 0.24);\n        color: color(neutral100);\n      }\n    }\n  }\n\n  svg {\n    fill: color(neutral100);\n  }\n}\n\n.text--on-surface {\n  border: none;\n  background-color: transparent;\n  padding: 0 4px;\n  min-height: 0;\n  width: auto;\n\n  svg {\n    margin-right: 0;\n    margin-top: 1px;\n  }\n\n  &--icon-left {\n    text-align: left;\n\n    svg {\n      margin-right: 6px;\n      margin-left: 0;\n    }\n  }\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(primary600);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(primary700, true), 0.24);\n        color: color(primary700);\n      }\n    }\n  }\n\n  svg {\n    fill: color(primary600);\n  }\n\n  &--disabled {\n    opacity: 0.3;\n\n    &:hover,\n    &:focus {\n      color: color(primary600);\n    }\n  }\n}\n\n.text--on-primary {\n  border: none;\n  background-color: transparent;\n  padding: 0 4px;\n  min-height: 0;\n  width: auto;\n\n  svg {\n    margin-right: 0;\n    margin-top: 1px;\n  }\n\n  &--icon-left {\n    text-align: left;\n\n    svg {\n      margin-right: 6px;\n      margin-left: 0;\n    }\n  }\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(surface1);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(surface1, true), 0.24);\n        color: color(surface1);\n      }\n    }\n  }\n\n  svg {\n    fill: color(surface1);\n  }\n\n  &--disabled {\n    opacity: 0.3;\n\n    &:hover,\n    &:focus {\n      color: color(primary600);\n    }\n  }\n}\n\n.text--on-primary-brand {\n  border: none;\n  background-color: transparent;\n  padding: 0 4px;\n  min-height: 0;\n  width: auto;\n\n  svg {\n    margin-right: 0;\n    margin-top: 1px;\n  }\n\n  &--icon-left {\n    text-align: left;\n\n    svg {\n      margin-right: 6px;\n      margin-left: 0;\n    }\n  }\n\n  &,\n  &:hover,\n  &:focus {\n    color: color(neutral100);\n  }\n\n  &--loaded {\n    &:hover,\n    &:focus {\n      &:not([disabled]) {\n        background-color: rgba(color(neutral100, true), 0.24);\n        color: color(neutral100);\n      }\n    }\n  }\n\n  svg {\n    fill: color(neutral100);\n  }\n\n  &--disabled {\n    opacity: 0.3;\n\n    &:hover,\n    &:focus {\n      color: color(primary600);\n    }\n  }\n}\n\n.toggle-on {\n  color: color(primary600);\n  border: 1px solid color(primary600);\n  background-color: rgba(color(primary600, true), 0.15);\n}\n\n.toggle-off {\n  color: color(neutral75);\n  border: 1px solid color(neutral75);\n  background-color: transparent;\n\n  @include hocus {\n    background-color: rgba(color(neutral75, true), 0.15);\n  }\n}\n\n/**************************************************/\n\n.loading {\n  &,\n  &:hover,\n  &:focus {\n    cursor: default;\n    color: rgba(color(neutral100, true), 0);\n  }\n\n  svg * {\n    opacity: 0;\n  }\n}\n\n/* rtl:begin:ignore */\n@keyframes :local(spin) {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n/* rtl:end:ignore */\n\n.spinner {\n  :local {\n    animation: spin 0.75s infinite linear;\n  }\n  height: 22px;\n  width: 22px;\n\n  &__wrapper {\n    height: 22px;\n    width: 22px;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    position: absolute;\n  }\n}\n\n.non-inline-anchor--disabled {\n  opacity: 0.3;\n}\n","@import '../functions/color';\n\n@mixin focus-outline($color: color(focus), $applyDirectly: false) {\n  @if $applyDirectly {\n    outline: $color solid 2px;\n    outline-offset: 3px;\n  } @else {\n    &:focus {\n      outline: $color solid 2px;\n      outline-offset: 3px;\n    }\n  }\n}\n","// Hocus\n// Generate :hover and :focus styles in one go.\n// http://www.456bereastreet.com/archive/201004/whenever_you_use_hover_also_use_focus/\n\n@mixin hocus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin notDisabledHocus() {\n  &:hover:not(:disabled),\n  &:focus:not(:disabled) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button-module__button___zGbs9`,
	"button--icon-left": `button-module__button--icon-left___ewWST`,
	"button--flex": `button-module__button--flex___FWCq5`,
	"button--inline-flex": `button-module__button--inline-flex___AVlj_`,
	"button--teal-outline": `button-module__button--teal-outline___GcWX1`,
	"button--blue-outline": `button-module__button--blue-outline___GiQlK`,
	"x-large": `button-module__x-large___DR8L_`,
	"large": `button-module__large___InIX7`,
	"small": `button-module__small___uWCNe`,
	"x-small": `button-module__x-small___S6ynG`,
	"contained--on-surface": `button-module__contained--on-surface___hXhlB`,
	"contained--on-surface--loaded": `button-module__contained--on-surface--loaded___G_UoE`,
	"contained--on-surface-delete": `button-module__contained--on-surface-delete___CWK5V`,
	"contained--on-surface-delete--loaded": `button-module__contained--on-surface-delete--loaded___uUul4`,
	"contained--on-primary": `button-module__contained--on-primary___pCwlK`,
	"contained--on-primary--loaded": `button-module__contained--on-primary--loaded___OEkUF`,
	"contained--on-primary-brand": `button-module__contained--on-primary-brand___JfAxd`,
	"contained--on-primary-brand--loaded": `button-module__contained--on-primary-brand--loaded___xit9c`,
	"outlined--on-surface": `button-module__outlined--on-surface___Roeju`,
	"outlined--on-surface--loaded": `button-module__outlined--on-surface--loaded___oKgh8`,
	"outlined--on-surface-delete": `button-module__outlined--on-surface-delete___PoSCq`,
	"outlined--on-surface-delete--loaded": `button-module__outlined--on-surface-delete--loaded___6xkOD`,
	"outlined--on-primary": `button-module__outlined--on-primary___STG6N`,
	"outlined--on-primary--loaded": `button-module__outlined--on-primary--loaded___aVhAd`,
	"outlined--on-primary-brand": `button-module__outlined--on-primary-brand___Yh2Mb`,
	"outlined--on-primary-brand--loaded": `button-module__outlined--on-primary-brand--loaded___xzKeV`,
	"text--on-surface": `button-module__text--on-surface___Dx7M6`,
	"text--on-surface--icon-left": `button-module__text--on-surface--icon-left___BhnEN`,
	"text--on-surface--loaded": `button-module__text--on-surface--loaded___te3zH`,
	"text--on-surface--disabled": `button-module__text--on-surface--disabled___I99GA`,
	"text--on-primary": `button-module__text--on-primary___erlw5`,
	"text--on-primary--icon-left": `button-module__text--on-primary--icon-left___PrUFA`,
	"text--on-primary--loaded": `button-module__text--on-primary--loaded___ZYTRC`,
	"text--on-primary--disabled": `button-module__text--on-primary--disabled___Po7Ip`,
	"text--on-primary-brand": `button-module__text--on-primary-brand___xAbaZ`,
	"text--on-primary-brand--icon-left": `button-module__text--on-primary-brand--icon-left___vEC0M`,
	"text--on-primary-brand--loaded": `button-module__text--on-primary-brand--loaded___zrpVR`,
	"text--on-primary-brand--disabled": `button-module__text--on-primary-brand--disabled___VHr7I`,
	"toggle-on": `button-module__toggle-on___gFIp3`,
	"toggle-off": `button-module__toggle-off___CS8K0`,
	"loading": `button-module__loading___cyMW5`,
	"spinner": `button-module__spinner___moqCn`,
	"spin": `button-module__spin___KY71k`,
	"spinner__wrapper": `button-module__spinner__wrapper___EvrkF`,
	"non-inline-anchor--disabled": `button-module__non-inline-anchor--disabled___ZcJz8`
};
export default ___CSS_LOADER_EXPORT___;
